import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { createAgentPhoneNumber, deleteAgentPhoneNumber, getPhoneNumbers } from './api';
import { queryClient } from 'providers/AllProviders';
import { PhoneNumbersResponse } from './types';
import { useParams } from 'react-router-dom';

export function useGetPhoneNumbers(
  countryCode: string,
  areaCode: string,
  options?: UseQueryOptions<PhoneNumbersResponse, Error>,
  numberType?: string,
  showNumber?: string | boolean | null
) {
  const { workspaceId, agentId } = useParams<{ workspaceId: string; agentId: string }>();

  return useQuery<PhoneNumbersResponse>({
    queryKey: ['phoneNumbers', workspaceId, agentId, countryCode, areaCode, numberType],
    queryFn: () => getPhoneNumbers(workspaceId!, agentId!, countryCode, areaCode, numberType),
    enabled: Boolean(workspaceId && agentId && countryCode && areaCode && numberType && showNumber),
    ...options
  });
}

export function useCreateAgentPhoneNumber() {
  const { workspaceId, agentId } = useParams<{ workspaceId: string; agentId: string }>();

  return useMutation({
    mutationFn: (payload: any) => createAgentPhoneNumber(workspaceId!, agentId!, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['agent', workspaceId, agentId],
        refetchType: 'active'
      });
    }
  });
}

export function useDeleteAgentPhoneNumber() {
  const { workspaceId, agentId } = useParams<{ workspaceId: string; agentId: string }>();

  return useMutation({
    mutationFn: () => deleteAgentPhoneNumber(workspaceId!, agentId!),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['agent', workspaceId, agentId],
        refetchType: 'active'
      });
    }
  });
}
